import { EM_DASH, formatCurrency } from "routes/custom_tables/grid/cellHelpers";

export default function CurrencyCell({ value }) {
  return value == null || value === "" ? (
    <span className="tw:text-muted-foreground">{EM_DASH}</span>
  ) : (
    <span className="tw:block tw:truncate">{formatCurrency(value)}</span>
  );
}
